export default __webpack_public_path__ + "static/media/name-icon.7ecf62d6.svg";